<template>
    <div class="wrapper">
        <p class="title">{{ $t("userAMLQuestionnaire.fourthStep.labelOne") }}</p>
        <p class="message message--1">{{ $t("userAMLQuestionnaire.fourthStep.labelTwo") }}</p>
        <p class="message message--2">{{ $t("userAMLQuestionnaire.fourthStep.labelThree") }}</p>

        <div class="options-wrapper">
            <input-checkbox
                v-for="(option, index) in options"
                :key="index"
                :value="option.checked"
                :index="index"
                :text="option.text"
                :maxWidth="false"
                isWholeAreaClickable
                noBackground
                @toggleCheckBox="handleOptionChanged"
            />
        </div>
        <input v-if="isOtherSourceOfIncomeChecked"
            v-model="otherSourceOfIncome"
            type="text"
            :placeholder="$t('userAMLQuestionnaire.fourthStep.sourceOfIncome')"
            :class="['income label__input', { 'label__input--active': otherSourceOfIncome }]"
            @input="handleTextChanged"
        >
    </div>
</template>

<script>
// Components
import inputCheckbox from '@webapp/components/inputs/input-checkbox.vue';

export default {
    name: 'question-4',
    components: {
        inputCheckbox,
    },
    data() {
        return {
            otherSourceOfIncome: '',
            options: [
                {
                    checked: false,
                    text: this.$t('userAMLQuestionnaire.fourthStep.employment'),
                    value: 'employment',
                },
                {
                    checked: false,
                    text: this.$t('userAMLQuestionnaire.fourthStep.gifts_donations'),
                    value: 'gifts_donations',
                },
                {
                    checked: false,
                    text: this.$t('userAMLQuestionnaire.fourthStep.investments_cryptotrading'),
                    value: 'investments_cryptotrading',
                },
                {
                    checked: false,
                    text: this.$t('userAMLQuestionnaire.fourthStep.inheritance'),
                    value: 'inheritance',
                },
                {
                    checked: false,
                    text: this.$t('userAMLQuestionnaire.fourthStep.savings'),
                    value: 'savings',
                },
                {
                    checked: false,
                    text: this.$t('userAMLQuestionnaire.fourthStep.winnings'),
                    value: 'winnings',
                },
                {
                    checked: false,
                    text: this.$t('userAMLQuestionnaire.fourthStep.other'),
                    value: 'other',
                },
            ],
        };
    },
    computed: {
        isOtherSourceOfIncomeChecked() {
            const otherSourceOfIncomeIndex = this.options.findIndex((opt) => opt.value === 'other');

            return this.options[otherSourceOfIncomeIndex].checked;
        },
    },
    methods: {
        emitCompleted() {
            this.$emit('completed', {
                sourcesOfIncome: this.options.filter((opt) => opt.checked).map((opt) => opt.value),
                sourceOfIncomeOther: this.otherSourceOfIncome,
            });
        },
        handleOptionChanged({ index }) {
            this.options[index].checked = !this.options[index].checked;

            if (!this.options[index].checked && this.options[index].value === 'other') {
                this.otherSourceOfIncome = '';
            }

            if (this.options.every((opt) => opt.checked === false) || (this.isOtherSourceOfIncomeChecked && !this.otherSourceOfIncome)) {
                this.$emit('in-progress');

                return;
            }

            this.emitCompleted();
        },
        handleTextChanged() {
            if (!this.otherSourceOfIncome) {
                this.$emit('in-progress');

                return;
            }

            this.emitCompleted();
        },
        resetStep() {
            this.options.forEach((option) => {
                option.checked = false;
            });
            this.otherSourceOfIncome = '';
        },
    },
};
</script>

<style lang="scss" scoped>
.wrapper {
    .title {
        font-size: 1.75rem;
        line-height: 23px;
    }

    .message {
        font-size: 1.65rem;
        line-height: 18px;
        font-weight: bold;

        /* stylelint-disable */
        &--1 {
            margin-top: 30px;
            margin-bottom: 0px;
        }

        &--2 {
            margin-top: 0px;
            margin-bottom: 30px;
        }
        /* stylelint-enable */
    }

    .income {
        max-width: 400px;
        margin-left: 28px;
    }

    ::v-deep {
        .checkbox {
            /* stylelint-disable */
            padding: 0px;
            margin: 12px 0px;
            /* stylelint-enable */
        }
    }
}
</style>